import "./divider.layout.css";

const Divider: React.FC = () => {
  return (
    <div className="divider-container">
      <hr className="divider"></hr>
    </div>
  );
};

export default Divider;
